import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Palette, LogOut, LayoutGrid, PackageCheck, Settings as SettingsIcon } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <nav className="bg-stone-50 border-b-2 border-stone-900 sticky top-0 z-40" data-testid="app-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
          <div className="w-9 h-9 bg-yellow-300 border-2 border-stone-900 rounded-md flex items-center justify-center hard-shadow-sm">
            <Palette className="w-5 h-5 text-stone-900" />
          </div>
          <div className="leading-none">
            <div className="font-heading font-black text-lg text-stone-900">CanvasKit</div>
            <div className="font-display text-sm text-stone-600 -mt-1">customize anything</div>
          </div>
        </Link>

        <div className="flex items-center gap-2">
          {user ? (
            <>
              <Link to="/dashboard" className="brutal-btn bg-white px-3 py-2 rounded-md flex items-center gap-2 text-sm" data-testid="nav-dashboard">
                <LayoutGrid className="w-4 h-4" /> Templates
              </Link>
              <Link to="/orders" className="brutal-btn bg-pink-200 px-3 py-2 rounded-md flex items-center gap-2 text-sm" data-testid="nav-orders">
                <PackageCheck className="w-4 h-4" /> Orders
              </Link>
              <Link to="/settings" className="brutal-btn bg-white px-3 py-2 rounded-md flex items-center gap-2 text-sm" data-testid="nav-settings">
                <SettingsIcon className="w-4 h-4" /> Settings
              </Link>
              <button
                onClick={() => { logout(); nav("/"); }}
                className="brutal-btn bg-white px-3 py-2 rounded-md flex items-center gap-2 text-sm"
                data-testid="nav-logout"
              >
                <LogOut className="w-4 h-4" /> Logout
              </button>
            </>
          ) : (
            <Link to="/login" className="brutal-btn bg-yellow-300 px-4 py-2 rounded-md text-sm" data-testid="nav-login">
              Seller Login
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}
